import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JiraFieldSchemeAri } from '@atlassian/ari/jira/field-scheme';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import FieldSchemePageQuery, {
	type FieldSchemePageQuery as FieldSchemePageQueryType,
} from './__generated__/FieldSchemePageQuery.graphql';

type GlobalAdminFieldSchemeEntryPointComponent = EntryPointComponent<
	{
		fieldSchemePageQuery: FieldSchemePageQueryType;
	},
	{},
	{},
	{
		schemeId: string;
	}
>;

export const globalAdminFieldSchemeEntryPoint: EntryPoint<
	GlobalAdminFieldSchemeEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<GlobalAdminFieldSchemeEntryPointComponent>(
		/* webpackChunkName: "async-jira-admin-pages-field-scheme" */ './FieldSchemeApp.tsx',
	),
	getPreloadProps: ({ context: { match }, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			fieldSchemePageQuery: {
				parameters: FieldSchemePageQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					schemeId: match.params?.schemeId || '',
					input: {
						schemeId: match.params?.schemeId || '',
					},
					availableOnInput: {
						schemeOrProject: {
							schemeId: match.params?.schemeId || '',
						},
					},
					descriptionsInput: {
						schemeOrProject: {
							schemeId: match.params?.schemeId || '',
						},
					},
					requiredOnInput: {
						schemeOrProject: {
							schemeId: match.params?.schemeId || '',
						},
					},
					fieldSchemeAri: match.params?.schemeId
						? JiraFieldSchemeAri.create({
								siteId: tenantContext.cloudId,
								activationId: tenantContext.activationId,
								fieldSchemeId: match.params.schemeId,
							}).toString()
						: '',
					isPerSchemeFieldLimitEnabled:
						fg('limits_enforcement_via_backend') || fg('mc-nfa-enforce-project-field-limits'),
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
		extraProps: {
			schemeId: match.params?.schemeId || '',
		},
	}),
});
